import React, { Component, useEffect, useState } from 'react'
import {alertActions, certboxActions} from '../../../../store/actions';
import { connect } from 'react-redux'
import Input from '../../../../module/input'
import history from "../../../../route/history";

const PwdPopup = (props) => {

  const [passwd, setPasswd] = useState('')

  const [state, setState] = useState({})

  /**
   * 비밀번호 유효성 체크
   */
  const goNext = () => {
    if (passwd?.length <= 0) {
      setState({
        ...state,
        errMessage: '비밀번호를 입력해주세요.',
      })
    } else {
		if(props.certboxpwd === passwd){
		      setState({
		        ...state,
		        errMessage: '',
		      })
    		props.onNext()
    		props.onClose()
		}else{
		      setState({
		        ...state,
		        errMessage: '비밀번호가 일치하지 않습니다.',
		      })
		}
    }
  }

  const handleChange = (e) => {
    const { value } = e.target
    setPasswd(value)
  }

  const handleClose = () => {
    props.onClose()
  }

  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '1',
  }

  let styleModal = {
    position: 'absolute',
    opacity: '1',
    zIndex: '2',
    display: 'block',
  }
  
  return (
    <React.Fragment>
      <div style={style}></div>
      <div style={styleModal} className="modal w450">
        <div className="modal-head">
          <h2>증명서 1회 열람 비밀번호 확인</h2>
        </div>

        <div className="modal-cont">
          <dl className="dl-form">
            <dt>비밀번호</dt>
            <dd>
              <Input
                type="password"
                className="form-control input-text m-b-20"
                placeholder="비밀번호"
                id="passwd"
                name="passwd"
                onChange={handleChange}
                value={passwd || ''}
                errMessage={state?.errMessage}
              />
            </dd>
          </dl>
          <div className="btn-block center">
            <a href="#" className="btn-secondary md b-close" onClick={handleClose}>
              취소
            </a>
            <a href="#" className="btn-primary md b-close" onClick={goNext}>
              확인
            </a>
          </div>

          <button type="button" className="modal-close b-close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    certbox: state.certbox,
  }
}
const actionCreators = {
  showPwdPopup: certboxActions.showPwdPopup,
}

export default connect(mapStateToProps, actionCreators)(PwdPopup)
